<template>
  <div id="DaneWejsciowe">
    <!-- <h4>Dane wejściowe</h4> -->
    <form>
      <div class="form-group">
        <label for="czas_podtrzymania">{{$t('message.hold_time')}}</label>
        <select class="form-control form-control-sm" id="czas_podtrzymania"
        v-model="inputData.czas_podtrzymania.value"
        @change="changeInputs('czas_podtrzymania')">
          <option v-for="item in config.QUIESCENT_MODE_ARRAY" :value="item" :key="item">{{item}}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="czas_alarmowania">{{$t('message.alarm_time')}}</label>
        <input type="text" class="form-control form-control-sm" value="0.5" id="czas_alarmowania"
        v-model="inputData.czas_alarmowania.value"
        readonly>
      </div>
      <div class="form-group">
        <label for="wsp_bezpieczenstwa">{{$t('message.inc_safety')}}</label>
        <input type="text" class="form-control form-control-sm" value="30" id="wsp_bezpieczenstwa"
        readonly>
      </div>
      <div class="form-group">
        <label for="dodatkowe_u">{{$t('message.extra_u')}}</label>
        <input type="number" value="0" :min="inputs.dodatkowe_u.min" :max="inputs.dodatkowe_u.max" class="form-control form-control-sm" id="dodatkowe_u"
        v-model="inputData.dodatkowe_u.value"
        @change="checkValue('dodatkowe_u')">

        <!-- <div class="number-input">
          <button @click.prevent="(inputData.dodatkowe_u.value === inputs.dodatkowe_u.min ) ? 0 : inputData.dodatkowe_u.value--" :min="inputs.dodatkowe_u.min" :max="inputs.dodatkowe_u.max"></button>
          <input id="dodatkowe_u" class="form-control form-control-sm" min="0" name="quantity" value="0"  type="number" v-model="inputData.dodatkowe_u.value" @change="checkValue('dodatkowe_u')">
          <button @click.prevent="(inputData.dodatkowe_u.value === inputs.dodatkowe_u.max) ? inputs.dodatkowe_u.max : inputData.dodatkowe_u.value++" :min="inputs.dodatkowe_u.min" :max="inputs.dodatkowe_u.max" class="plus"></button>
        </div> -->

      </div>

      <div class="form-group">
        <label for="glebokosc_szafy" style="width:198px">{{$t('message.depth_cabinet')}}</label>
        <md-avatar>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill" viewBox="0 0 16 16" style="margin-right: 4px; color: #3ba3ff;cursor: pointer;width:18px;position: relative;top: 0px;">
          <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
        </svg>
          <md-tooltip md-direction="right" class="tooltipShort" v-html="$t('message.depth_cabinet_info')">
          </md-tooltip>
        </md-avatar>
        <select class="form-control form-control-sm" id="glebokosc_szafy"
        :disabled = !check_depth
        v-model="inputData.glebokosc_szafy.value"
        @change="changeInputs('glebokosc_szafy'), changeDepthCabinet()">
          <option v-for="item in inputs.glebokosc.value" :value="item" :key="item">{{item}}</option>
        </select>
      </div>

      <div class="form-group">
        <label for="przylacze_zasilania" style="width:198px">{{$t('message.przylacze_zasilania')}}</label>
        <select class="form-control form-control-sm" id="przylacze_zasilania" v-model="inputData.przylacze_zasilania.value" @change="changeInputs('przylacze_zasilania')">
          <option v-if="outputs['qtyClusters'].value < 3" value="1">{{$t('message.faza1')}}</option>
          <option value="3">{{$t('message.faza3')}}</option>
        </select>
      </div>
    </form>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../mixins/app'
import { materials } from '../mixins/materials'
import { calculation } from '../mixins/calculation'

export default {
  name: 'DaneWejsciowe',
  mixins: [app, materials, calculation],
  data () {
    return {
      inputData: {
        czas_podtrzymania: {'value': 24},
        czas_alarmowania: {'value': 0.5},
        dodatkowe_u: { 'value': 0, 'min': 0, 'max': 50 },
        glebokosc_szafy: {'value': 600, 'active': 0},
        przylacze_zasilania: {'value': '1'}
      }
    }
  },
  computed: {
    ...mapGetters('app', ['clearing']),
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('app', ['errors']),
    ...mapGetters('app', ['copyValues']),
    ...mapGetters('app', ['clusterOne']),
    ...mapGetters('app', ['clusterTwo']),
    ...mapGetters('app', ['clusterThree']),
    ...mapGetters('app', ['clusterFour']),
    ...mapGetters('app', ['clusterFive']),
    ...mapGetters('app', ['clusterSix']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaBosch']),
    ...mapGetters('products', ['ListaPulsar']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaMaterialy']),
    check_depth () {
      return this.inputs.glebokosc.value > 1 ? 0 : 1
    },
    change_dapth () {
      return (this.inputs.glebokosc.value.length < 2) ? this.inputs.glebokosc.value[0] : this.inputData.glebokosc_szafy.value
    },
    check_wentylator () {
      return (this.outputs.szafa && this.outputs.szafa.attributes.wysokosc > 24) ? 0 : 1
    }
  },
  watch: {
    inputs: {
      deep: true, // <!-- This is important;
      handler (newValue) {
        Object.keys(this.inputData).forEach(element => {
          this.inputData[element].value = newValue[element].value
        })
      }
    },
    clearing (newValue) {
      if (newValue === true) {
        this.inputData.czas_podtrzymania.value = 24
        this.inputData.czas_alarmowania.value = 0.5
        this.inputData.dodatkowe_u.value = 0
        this.inputData.glebokosc_szafy.value = 600
      }
    }
  },
  methods: {
    changeDepthCabinet () {
      var glebokosc = this.inputData.glebokosc_szafy.value
      var wysokosc = this.outputs.szafa.attributes.wysokosc
      var matchSzafa = []
      matchSzafa = this.ListaSzafy.filter(item => (item.attributes.wysokosc === wysokosc && item.attributes.glebokosc === glebokosc))
      this.changeValueOutputs('szafa', 'array', matchSzafa[0])
      //           this.changeValueOutputs('szafa_wolne_miejsce', 'value', wolneMiejsce)
      console.log('Dane wejsciowe - changeDepthCabinet')
      this.obliczenia_sprzetowe()
    }
  }
}
</script>

<style scoped>
  form {
    width:345px
  }
  form .form-group {
    width:100%
  }
  form .form-group label {
    width: 275px
  }
  form .form-group select {
    width: 70px
  }
  form .form-group div {
    margin-right: 0px;
  }
  .md-avatar {
      width: 0px;
      min-width: 20px;
      height: 28px;
      border-radius: 0px;
  }

  .tooltipShort  {
    padding:10px;
    width:235px;
    height:65px;
    font-size: 14px;
  }
  .wariant-label {
    width:74px;
  }
  .wariant-input {
    /* position: relative;
    left: -48px;
    top: 4px;*/
    width:70px
  }
  .wariant-rozszerzenia-input {
    /* position: relative;
    right: 2px;
    top: 4px; */
    width: 70px;
  }
  .wariant-span {
    font-size: 13px;
    margin: 0px 12px;
  }

  #przylacze_zasilania {
    width:150px
  }
/* input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

.number-input {
  border: 0;
  display: inline-flex;
}

.number-input,
.number-input * {
  box-sizing: border-box;
}

  .number-input button {
  outline:none;
  -webkit-appearance: none;
  background-color: transparent;
  border: none;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
  margin: 0;
  position: relative;
  box-shadow: 0px 0px 1px #474747;
    border-radius: 5px;
}

.number-input button:before,
.number-input button:after {
  display: inline-block;
  position: absolute;
  content: '';
  width: 0.8rem;
  height: 2px;
  background-color: #212121;
  transform: translate(-50%, -50%);
}
.number-input button.plus:after {
  transform: translate(-50%, -50%) rotate(90deg);
} */

/* .number-input input[type=number] {
  font-family: sans-serif;
  max-width: 5rem;
  padding: .5rem;
  border: none;
  border-width: 0 2px;
  font-size: 2rem;
  height: 3rem;
  font-weight: bold;
  text-align: center;
  color:#9be3df;
} */

</style>



// WEBPACK FOOTER //
// src/components/DaneWejsciowe.vue